module.exports = __webpack_public_path__ + "img/sialogo.335bd294.png";